import { ContactName } from '@uplift/api';
import { useL10n } from '@uplift/hooks';
import { MaskedInput } from '../../../../Inputs';
import { useSettingsStyles } from '../styles';


export const PhoneForm: React.VFC<{ showWorkContact?: boolean }> = ({ showWorkContact = true }) => {
  const { classes } = useSettingsStyles();
  const l10n = useL10n();

  return (
    <div className={classes.formGroup}>
      <MaskedInput
        label={l10n.accountSettings.profile.mobile}
        name={ContactName.mobile}
        fullWidth
        type="phone"
      />
      {showWorkContact && (
        <MaskedInput
          label="Work"
          name={ContactName.work}
          fullWidth
          type="phone"
        />
      )}
      <MaskedInput
        label={l10n.accountSettings.isOptional(l10n.accountSettings.profile.home)}
        name={ContactName.home}
        fullWidth
        type="phone"
      />
    </div>
  );
};
